import React from "react";
import style from "./index.module.scss";
import { Button } from "antd";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import Config from "../../../../../../config";

interface WeekPickerProps {
    week: number;
    onChange: (week: number) => void;
}

export default function WeekPicker({ week, onChange }: WeekPickerProps) {
    return (
        <div className={style.root}>
            <Button
                type="link"
                className={style.btn}
                onClick={() => onChange(Math.max(week - 1, 1))}
                disabled={week === 1}>
                <IoIosArrowBack />
            </Button>

            <span>第 {week} 周</span>

            <Button
                type="link"
                className={style.btn}
                onClick={() => onChange(Math.min(week + 1, Config.MaxWeek))}
                disabled={week === Config.MaxWeek}>
                <IoIosArrowForward />
            </Button>
        </div>
    );
}
